import { controls } from "../controls";

const ms446 = {
  label: "Agri Loan NPA Entry Master",
  pageLabel: "Agri Loan NPA Entry Master",
  starting: true,
  url: "ms446",
  bulk: { columns: ["branch_display", "cin", "product_code_display", "account_number", "npa_date", "future_credits", "demand"] },
  formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", width: "col-sm-2", displaytype: 'small' }),

    ...controls.displayText({ tab: "filter", label: "Customer Number", width: "col-sm-2" }),
    ...controls.customerNumber({ tab: "filter" }),
    ...controls.showData({ tab: "filter", data: "customer_number_display", name: "customer_number_display", width: "col-sm-2", displaytype: 'titlecase' }),



    ...controls.displayText({ tab: "filter", label: "Product Code", width: "col-sm-2" }),
    ...controls.product({ tab: "filter" }),
    ...controls.showData({ tab: "filter", data: "product_code_display", name: "product_code_display", width: "col-sm-2", displaytype: 'camelcase' }),

    ...controls.displayText({ tab: "filter", label: "Account Number", width: "col-sm-2" }),
    ...controls.AccountNumber({ tab: "filter", forceRender: true, beforeLeave: ["createAcNo"] }),
    ...controls.showData({ tab: "filter", data: "account_number_display", name: "account_number", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "NPA Date", star: true, width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", isRequired: true, name: "npa_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "Future Credits", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", name: "future_credits", width: "col-sm-2", placeHolder: "Future Credits" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "Demand", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", name: "demand", width: "col-sm-2", placeHolder: "Demand" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-2" }),
    ...controls.perPage({ tab: 'filter' }),
  ],


  form: [

    ...controls.displayText({ label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ defaultValue: "assigned_branch" }),
    ...controls.showData({ data: "branch_display", name: "branch_display", width: "col-sm-2", displaytype: 'small' }),

    ...controls.displayText({ label: "Customer Number", width: "col-sm-2" }),
    ...controls.customerNumber({ tab: "filter" }),
    ...controls.showData({ data: "customer_number_display", name: "customer_number_display", width: "col-sm-2", displaytype: 'titlecase' }),



    ...controls.displayText({ label: "Product Code", width: "col-sm-2" }),
    ...controls.product({ tab: "filter" }),
    ...controls.showData({ data: "product_code_display", name: "product_code_display", width: "col-sm-2", displaytype: 'camelcase' }),

    ...controls.displayText({ label: "Account Number", width: "col-sm-2" }),
    ...controls.AccountNumber({ forceRender: true, beforeLeave: ["createAcNo"] }),
    ...controls.showData({ data: "account_number", name: "account_number", width: "col-sm-2" }),

    ...controls.displayText({ label: "NPA Date", star: true, width: "col-sm-2 " }),
    ...controls.magicDate({ isRequired: true, name: "npa_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ label: "Future Credits", width: "col-sm-2" }),
    ...controls.numberOnly({ name: "future_credits", width: "col-sm-2", placeHolder: "Future Credits" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ label: "Demand", width: "col-sm-2" }),
    ...controls.numberOnly({ name: "demand", width: "col-sm-2", placeHolder: "Demand" }),

  ],
  history: {
    perPage: 10,
    reportHeader: "Agri Loan NPA Entry Master",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      {
        Header: "Parent Branch",
        accessor: "brcode",
        width: 140,
        rwidth: 50
      },
      {
        Header: "Custmor No",
        accessor: "cin",
        width: 140,
        rwidth: 50
      },





      {
        Header: "Product",
        accessor: "prodscn",
        width: 200,
        rwidth: 50
      },
      {
        Header: "Account Number",
        accessor: "acctcode",
        width: 120
      },
      {
        Header: "NPA Date",
        accessor: "npa_date",
        type: "date",
        width: 120
      },
      {
        Header: "Future Credits",
        accessor: "future_credits",
        width: 120
      },
      {
        Header: "Demand",
        accessor: "demand",
        width: 120
      }
    ]
  }
};

export default ms446;